module.exports = __webpack_public_path__ + "img/alitas.f3019be0.jpeg";